import * as tslib_1 from "tslib";
import { dialogStateActionTypes } from './ActionTypes';
import { DialogStateResponse } from '../../../globalTypes';
import DialogStateFetcher from '../../util/DialogStateFetcher';
export function getDialogState(dialogStateRequest) {
    var _this = this;
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var dialogState, dialogStateFetcher, loadingStateAction, loadingStateAction, error_1, errorCodes;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dialogState = new DialogStateResponse(0);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    dialogStateFetcher = DialogStateFetcher.getInstance();
                    if (dialogStateFetcher.isLoading()) {
                        dialogStateFetcher.abortLoading();
                    }
                    else if (typeof dialogStateRequest.dispatchLoadingState !== 'undefined' && dialogStateRequest.dispatchLoadingState) {
                        loadingStateAction = {
                            type: dialogStateActionTypes.DIALOG_LOADING_STATE
                        };
                        dispatch(loadingStateAction);
                    }
                    else {
                        loadingStateAction = {
                            type: dialogStateActionTypes.SILENT_LOADING_STATE
                        };
                        dispatch(loadingStateAction);
                    }
                    return [4 /*yield*/, dialogStateFetcher.fetchRequest(dialogStateRequest)];
                case 2:
                    dialogState = _a.sent();
                    if (typeof dialogState.isOk === 'undefined' || !dialogState.isOk()) {
                        throw new Error(dialogStateActionTypes.ERROR_DIALOG_STATE);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    errorCodes = [
                        dialogStateActionTypes.ABORTED_DIALOG_STATE,
                        dialogStateActionTypes.NO_CONNECTION_DIALOG_STATE,
                        dialogStateActionTypes.ERROR_DIALOG_STATE
                    ];
                    return [2 /*return*/, dispatch({
                            type: errorCodes.includes(error_1) ?
                                error_1 :
                                dialogStateActionTypes.ERROR_DIALOG_STATE
                        })];
                case 4: return [2 /*return*/, dispatch({
                        type: dialogStateActionTypes.RECEIVE_DIALOG_STATE,
                        dialogStateResponse: dialogState
                    })];
            }
        });
    }); };
}
;
export function sendPreBookRequest(dialogStateRequest) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(dialogStateRequest.url, {
                        method: 'POST',
                        headers: {
                            'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
                        },
                        body: dialogStateRequest.data,
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function storeRequest(stateStoreRequest) {
    var _this = this;
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var result, res, dialogStateStoreResponse, error_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = {
                        type: dialogStateActionTypes.DIALOG_STATE_SAVE_FAILED
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(stateStoreRequest.url, {
                            method: 'PUT',
                            mode: 'same-origin',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                //'Content-Type': 'application/json'
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            body: 'key=' + stateStoreRequest.key + (stateStoreRequest.urlencoded.length > 0 ? ('&' + stateStoreRequest.urlencoded) : '')
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    dialogStateStoreResponse = _a.sent();
                    if (dialogStateStoreResponse.header.state === 'OK') {
                        result = {
                            type: dialogStateActionTypes.DIALOG_STATE_SAVED
                        };
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, dispatch(result)];
            }
        });
    }); };
}
;
export function sendMessages(messages) {
    var _this = this;
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var dialogStateResponse;
        return tslib_1.__generator(this, function (_a) {
            dialogStateResponse = new DialogStateResponse(200);
            dialogStateResponse.setDialogMessages(messages);
            return [2 /*return*/, dispatch({
                    'type': dialogStateActionTypes.DIALOG_MESSAGES_SEND,
                    'dialogStateResponse': dialogStateResponse
                })];
        });
    }); };
}
;
